<template>
  <div
    class="baseGrid"
    :style="gridStyle"
  >
    <slot />
  </div>
</template>

<script setup>
const props = defineProps({
	gap: {
		type: String,
		default: 'medium'
	}
});
const gapComputed = computed(() => {
	return `var(--spacer-${props.gap})`;
});

const gridStyle = computed(() => {
	return {
		display: 'grid',
		gridGap: gapComputed.value
	};
});

</script>

<style scoped>
.baseGrid {
  display: grid;
}
</style>
